import { render, staticRenderFns } from "./HtmlWrapper.vue?vue&type=template&id=64673796&scoped=true"
import script from "./HtmlWrapper.vue?vue&type=script&lang=js"
export * from "./HtmlWrapper.vue?vue&type=script&lang=js"
import style0 from "./HtmlWrapper.vue?vue&type=style&index=0&id=64673796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64673796",
  null
  
)

export default component.exports